









































import { EventBus, hasElements, TypeEventBus } from '../../core/utils';
import { JourneysService } from '../../journeys/api/JourneysService';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { RootStoreHelper, StoreHelper } from '../../core/mixins';
import { Mounted } from '../../core/decorators';

@Component({
    components: {}
})
export default class modalConfirmation extends Mixins(StoreHelper, RootStoreHelper) {
    modalQuestion: string = '';
    visible: boolean = true;
    processingRequest: boolean = false;
    seeDetailJourney: boolean = false;
    completeAction: boolean = false;
    journeyId: string = '';
    modalWidth: string = '576';

    @Prop() action: string;
    @Prop() json: any;

    @Mounted
    ready() {
        this.loadModalData();
    }

    loadModalData() {
        if (this.action === 'unprocess') {
            this.changeModalQuestion('¿Está seguro que desea declarar como "No procesada" esta Jornada?');
        } else if (this.action === 'process') {
            this.changeModalQuestion('¿Está seguro que desea declarar como "Procesada" esta Jornada?');
            this.setModalWidth('754');
        } else if (this.action === 'markAsError') {
            this.setModalWidth('478');
            this.changeModalQuestion('¿Está seguro que desea marcar como error esta Jornada?');
        } else if (this.action === 'unMarkAsError') {
            this.setModalWidth('430');
            this.changeModalQuestion('¿Está seguro que desea desmarcar como error esta Jornada?');
        } else if (this.action === 'errorExportExcel') {
            this.setModalWidth('387');
            this.changeModalQuestion('No se pudo exportar el archivo. Intente nuevamente');
            this.completeAction = true;
        } else if (this.action === 'deleteCommentary') {
            this.setModalWidth('411');
            this.changeModalQuestion('¿Está seguro que desea eliminar el comentario?');
        } else if (this.action === 'createJourney') {
            this.setModalWidth('516');
            this.changeModalQuestion('¿Está seguro que desea crear esta jornada?');
        } else if (this.action === 'forceCloseJourney') {
            this.setModalWidth('469');
            this.changeModalQuestion('¿Está seguro que desea forzar el cierre de esta jornada?');
        } else if (this.action === 'deleteJourney') {
            this.setModalWidth('561');
            this.changeModalQuestion('¿Está seguro que desea eliminar ésta jornada?');
        } else if (this.action === 'modifyJourney') {
            this.setModalWidth('578');
            this.changeModalQuestion('¿Está seguro que desea modificar ésta jornada?');
        } else if (this.action === 'restoreJourney') {
            this.setModalWidth('595');
            this.changeModalQuestion('¿Está seguro que desea restaurar ésta jornada?');
        } else if (this.action === 'loadOriginalValues') {
            this.setModalWidth('595');
            this.changeModalQuestion('¿Está seguro que desea cargar el cálculo original?');
        }
    }

    getConfirmAction() {
        if (this.action === 'unprocess') {
            this.unProcessJourney();
        } else if (this.action === 'process') {
            this.processJourney();
        } else if (this.action === 'markAsError') {
            this.markAsError();
        } else if (this.action === 'unMarkAsError') {
            this.unMarkAsError();
        } else if (this.action === 'deleteCommentary') {
            this.processingEvent();
            EventBus.$emit(TypeEventBus.DELETE_COMMENTARY);
            this.closeModal();
        } else if (this.action === 'createJourney') {
            this.createJourney();
        } else if (this.action === 'forceCloseJourney') {
            this.forceCloseJourney();
        } else if (this.action === 'deleteJourney') {
            this.deleteJourney();
        } else if (this.action === 'modifyJourney') {
            this.modifyJourney();
        } else if (this.action === 'restoreJourney') {
            this.restoreJourney();
        } else if (this.action === 'loadOriginalValues') {
            this.loadOriginalValues();
        }
    }

    seeJourney() {
        let link = '/journeys/information/' + this.journeyId;
        window.location.replace(link);
        this.journeyId = '';
        this.seeDetailJourney = false;
        this.endAction();
    }

    endAction() {
        this.closeModal();
        this.$emit('close-modal-abm');
    }

    keydownEnterEvent() {
        if (this.action === 'forceCloseJourney') {
            this.closeModal();
        }
    }

    closeModal() {
        this.visible = false;
        this.$emit('close-modal', false);
    }

    processJourney() {
        this.showLoader();
        this.postJourney();
    }

    unProcessJourney() {
        this.showLoader();
        this.postJourney();
    }

    markAsError() {
        this.showLoader();
        this.postMarkAsError();
    }
    unMarkAsError() {
        this.showLoader();
        this.postMarkAsError();
    }
    postMarkAsError() {
        this.processingEvent();
        JourneysService.postMarkJourney(this.json)
            .then(response => {
                if (this.action === 'markAsError') {
                    this.$_setJourneyError(true);
                    this.completeRequest(response, response.message);
                } else {
                    this.setModalWidth('553');
                    this.$_setJourneyError(false);
                    this.completeRequest(response, response.message);
                }
            })
            .catch(error => {
                this.setModalWidth('531');
                if (error && error.response && error.response.data && error.response.data.message) {
                    this.completeRequest(error, error.response.data.message);
                } else {
                    this.completeRequest(error, 'Ocurrió un error');
                }
            });
    }
    postJourney() {
        this.processingEvent();
        JourneysService.postProcessJourney(this.json)
            .then(response => {
                if (this.action === 'unprocess') {
                    this.$_setJourneyStatus(false);
                    this.completeRequest(response, response.message);
                } else {
                    this.$_setJourneyStatus(true);
                    this.completeRequest(response, response.message);
                }
            })
            .catch(error => {
                this.setModalWidth('531');
                if (error && error.response && error.response.data && error.response.data.message) {
                    this.completeRequest(error, error.response.data.message);
                } else {
                    this.completeRequest(error, 'Ocurrió un error');
                }
            });
    }
    enableJourneyDetail(journeyId) {
        this.journeyId = journeyId;
        this.seeDetailJourney = true;
    }
    completeRequest(response, responseMessage) {
        //update event list
        EventBus.$emit(TypeEventBus.EVENTS_REFRESHED, response, true);
        this.changeModalQuestion(responseMessage);
        this.processingRequest = false;
        this.completeAction = true;
    }
    showLoader() {
        this.processingRequest = true;
    }
    processingEvent() {
        EventBus.$emit(TypeEventBus.PROCESSING_EVENTS);
    }

    createJourney() {
        this.$emit('create-journey');
        this.showLoader();
    }

    forceCloseJourney() {
        this.$emit('close-journey');
        this.showLoader();

        // setTimeout(() => {
        //   this.changeModalQuestion('Jornada cerrada con éxito');
        //   this.actionCompleted();
        // }, 2000);
    }

    deleteJourney() {
        this.$emit('delete-journey');
        this.showLoader();

        // setTimeout(() => {
        //   this.changeModalQuestion('Jornada eliminada con éxito');
        //   this.actionCompleted();
        // }, 2000);
    }

    modifyJourney() {
        this.$emit('patch-journey');
        this.showLoader();

        // setTimeout(() => {
        //   this.changeModalQuestion('Jornada modificada con éxito');
        //   this.actionCompleted();
        // }, 2000);
    }

    loadOriginalValues() {
        this.$emit('load-original-values');
        this.closeModal();
    }

    restoreJourney() {
        this.$emit('restore-journey');
        this.showLoader();

        // setTimeout(() => {
        //   this.changeModalQuestion('Jornada modificada con éxito');
        //   this.actionCompleted();
        // }, 2000);
    }

    actionCompleted() {
        this.processingRequest = false;
        this.completeAction = true;
    }

    changeModalQuestion(text) {
        this.modalQuestion = text;
    }

    setModalWidth(value) {
        this.modalWidth = value;
    }
}
